import { makeAutoObservable } from 'mobx';

import { GameType } from '../../model/enumeration/GameType.enum';
import { PokerRoom } from '../../model/enumeration/PokerRoom';
import { Player } from '../../model/Player';
import { TableResponse } from '../../model/TableResponse';
import { WaitingHostBot } from '../../model/WaitingHostBot';

export class GameTable {
  public id = '';
  public gameId?: string;
  public players: Player[] = [];
  public dealerPid: string;
  public playerStepDuration: number;
  public gameType: GameType;
  public currentGameType: GameType;
  public name: string;
  public limit: number;
  public limitInUsd: number;
  public bb: number;
  public lastPingEventTime: string;
  public deleted: boolean;
  public creatorUniqueId: string;
  public room: PokerRoom;
  public viewersCount: number;
  public waitlistCount: number;
  public waitingHostBots: WaitingHostBot[];
  public mttRemainingPlayers: number;

  public glowingPid: string = null;

  constructor() {
    makeAutoObservable(this);
  }

  initTable(table: TableResponse): void {
    Object.assign(this, table);
  }

  copyTable(table: GameTable): void {
    Object.assign(this, table);
  }

  setId(value: string): void {
    this.id = value;
  }

  setPlayers(value: (Player | null)[]): void {
    this.players = value;
  }

  setGameId(gameId: string): void {
    this.gameId = gameId;
  }

  setDealerPid(dealerPid: string): void {
    this.dealerPid = dealerPid;
  }

  setPlayerStepDuration(playerStepDuration: number): void {
    this.playerStepDuration = playerStepDuration;
  }

  setGameType(gameType: GameType): void {
    this.gameType = gameType;
  }

  setName(name: string): void {
    this.name = name;
  }

  setLimit(limit: number): void {
    this.limit = limit;
  }

  setLimitInUsd(limitInUsd: number): void {
    this.limitInUsd = limitInUsd;
  }

  setDeleted(deleted: boolean): void {
    this.deleted = deleted;
  }

  setGlowingPlayer(pid: string): void {
    this.glowingPid = pid;
  }

  removeGlowingPlayer(): void {
    this.glowingPid = null;
  }

  setViewersCount(viewersCount: number): void {
    this.viewersCount = viewersCount;
  }

  setWaitlistCount(waitlistCount: number): void {
    this.waitlistCount = waitlistCount;
  }

  addWaitingHostBot(bot: WaitingHostBot): void {
    if (!this.hasWaitingHostBot(bot.pid)) {
      this.waitingHostBots = [...this.waitingHostBots, bot];
    }
  }

  removeWaitingHostBot(pid: string): void {
    if (this.hasWaitingHostBot(pid)) {
      this.waitingHostBots = this.waitingHostBots.filter(
        bot => bot.pid !== pid,
      );
    }
  }

  removeWaitingHostBots(pids: string[]): void {
    this.waitingHostBots = this.waitingHostBots.filter(
      bot => !pids.includes(bot.pid),
    );
  }

  hasWaitingHostBot(pid: string): boolean {
    return this.waitingHostBots.some(bot => bot.pid === pid);
  }

  clearWaitingHostBots(): void {
    this.waitingHostBots = [];
  }
}
